// src/features/commission/components/CommissionInfoCard.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { Commission } from '../types/commission.types';
import { CommissionStatusBadge } from './CommissionStatusBadge';

export interface CommissionInfoCardProps {
  commission: Commission;
}

/**
 * Workspace card: core commission info. Pulls straight off the base
 * Commission record (same shape the list table already uses) — no
 * additional mock data needed for this one. Same field-list markup as
 * orders/components/OrderInfoCard.tsx.
 */
export function CommissionInfoCard({ commission }: CommissionInfoCardProps) {
  return (
    <Card className="vania-commission-workspace-card">
      <h2 className="vania-commission-workspace-card-title">اطلاعات کمیسیون</h2>

      <dl className="vania-commission-workspace-fieldlist">
        <div>
          <dt>شناسه کمیسیون</dt>
          <dd dir="ltr">{commission.id}</dd>
        </div>
        <div>
          <dt>مبلغ</dt>
          <dd dir="ltr">{formatPersianNumber(commission.amount)} تومان</dd>
        </div>
        <div>
          <dt>وضعیت</dt>
          <dd>
            <CommissionStatusBadge status={commission.status} />
          </dd>
        </div>
        <div>
          <dt>تاریخ ایجاد</dt>
          <dd dir="ltr">{`${commission.rate_applied * 100}%`}</dd>
        </div>
        <div>
          <dt>تاریخ ایجاد</dt>
          <dd dir="ltr">{formatSolarDate(commission.created_at || '-')}</dd>
        </div>
      </dl>
    </Card>
  );
}
